<template>
  <!-- grid-densa: ancora do teste de 9px SO nas grids desta tela. Ver scss/_custom.scss. -->
  <div class="grid-densa">
  <!-- ZC-43: quadro Status Despesas por Empresa acima das duas colunas. A tela de Diversos e um
       d-flex com col-md-3 + col-md-9, entao o quadro fica sobre a linha inteira, nao dentro de uma
       coluna. `apenas-empresas` deixa os 6 cards, o donut e o gasto por moeda no componente, para o
       submenu Dashboard do ZPag. `modulo="diversos"` troca o repositorio (criterio de consulta
       proprio, ver CRUDDespesasDiversos.GetVisaoGeralDespesasDiversos) e a sigla do status 2, que
       aqui e CONTROLADORIA. -->
  <VisaoGeralDespesas
    v-if="mostraVisaoGeral"
    :apenas-empresas="true"
    modulo="diversos"
    @navegar="onNavegar"
    ref="VisaoGeralDespesasRef" />
  <div class="d-flex">

    <div class="col-md-3"  v-if="!details">
      <div v-if="aba === 'prestacao'">
        <div class="justify-content-center mt-2 title-card-sales text-center">
          Total de Despesas
        </div>
        <div class="sales-value">{{ formatMoney(totalDespesas)}}</div>
      </div>
        <div class="mt-2" v-if="aba === 'prestacao'">
          <searchmiscellaneousreimbursement ref="SearchRef" @search="search"></searchmiscellaneousreimbursement>
        </div>
        <div class="mt-2" v-if="!details && ['colaboradores', 'desligamento', 'encerramento'].includes(aba)">
          <FilterSeveralContributor @search="search"></FilterSeveralContributor>
        </div>
        <div class="mt-2" v-if="aba === 'lotes'">
          <Filtermiscellaneouslots v-model="tabIndex" @search="search"></Filtermiscellaneouslots>
        </div>
        <div class="mt-2" v-if="aba === 'primeiroAdiantamento'">
          <painelFirstAdvanceMiscellaneous v-model="tabIndex" @search="search"></painelFirstAdvanceMiscellaneous>
        </div>
    </div>
    <div class="col-md-9" v-if="!details">
      <b-tabs v-model="tabIndex">
           <b-tab :title="'Autorizações'">
            <template slot="title">
              <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Prestação de Conta</span>
            </template>
            <Tablesearchmiscellaneousreimbursement :prestacao="prestacao" :initialFilter="pendingFilter"  @totalDespesas="totalDespesas = !$event ? 0 : $event" ref="tablesearchmiscellaneousreimbursement" @edit="edit" @filtro="filtro"></Tablesearchmiscellaneousreimbursement>
           </b-tab>
           <b-tab :title="'Autorizações'"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)  || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
            <template slot="title" >
              <i class="fas fa-user"></i><span class="d-md-down-none pl-1 text-third"> Colaboradores</span>
            </template>
            <tablecollaborator  @AtualizaPrestacao="AtualizaPrestacao" v-if="aba === 'colaboradores'" ref="tablecollaborator"></tablecollaborator>
           </b-tab>
           <b-tab :title="'Autorizações'" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)  || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
            <template slot="title" >
              <i class="fa fa-table"></i><span class="d-md-down-none pl-1 text-third"> Lotes Pagos</span>
            </template>
            <tablepaidlots v-if="aba === 'lotes'" ref="diversosLotes"></tablepaidlots>
           </b-tab>
           <b-tab :title="'Autorizações'" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)  || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
            <template slot="title" >
              <i class="far fa-money-bill-alt"></i><span class="d-md-down-none pl-1 text-third"> Primeiro Adiantamento</span>
            </template>
            <FirstAdvanceMiscellaneous v-if="aba === 'primeiroAdiantamento'" ref="primeiroAdiantamento"></FirstAdvanceMiscellaneous>
           </b-tab>
           <!-- ZPG-15: Processo de Desligamento e Encerramento de Diversos no fim. As abas do meio dependem de
                role, entao o indice de cada aba varia por usuario: a tela decide pela chave (computed `aba`). -->
           <b-tab :title="'Processo de Desligamento'">
            <template slot="title">
              <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Processo de desligamento</span>
            </template>
            <details-collaborator v-if="aba === 'desligamento'" ref="detailscollaborator"></details-collaborator>
           </b-tab>
           <b-tab :title="'Encerramento de Diversos'">
            <template slot="title">
              <i class="fas fa-user-slash text-third"></i><span class="d-md-down-none pl-1 text-third"> Encerramento de Diversos</span>
            </template>
            <encerramento-diversos v-if="aba === 'encerramento'" ref="encerramentodiversos"></encerramento-diversos>
           </b-tab>
      </b-tabs>
    </div>
    <div class="col-md-12" v-if="details">
      <detailsmiscellaneousreimbursement  @tableGrids="backTable" :filtroEmpresa="filtroEmpresa" :dataDetails="dataDetails" :despesasid="despesasid" ref="detailsmiscellaneousreimbursement" :totalFuncionarioDespesas="totalDespesas"></detailsmiscellaneousreimbursement>
    </div>
  </div>
  </div>
</template>

<script>
import MiscellaneousReimbursement from './miscellaneousreimbursement'
export default MiscellaneousReimbursement
</script>

<style scoped>
 .col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
 .title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.sales-value {
  width: 100%;
  height: 3rem;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  background-color: white;
  border-radius: 0px 0px 8px 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/miscellaneousreimbursement.vue